import { render } from "./ApprovedUsers.vue?vue&type=template&id=3c435373&scoped=true"
import script from "./ApprovedUsers.vue?vue&type=script&lang=js"
export * from "./ApprovedUsers.vue?vue&type=script&lang=js"

import "./ApprovedUsers.vue?vue&type=style&index=0&id=3c435373&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c435373"]])

export default __exports__